import React from 'react';
import moment from 'moment';
import { getLocalTime } from "../../../utils/dateUtility";
import { getGroupActivityDate } from "../../../utils/internalChatGroups";

/** Item sem data (ex.: grupo vazio que só veio da listagem) vai para o fim, na ordem
 *  em que chegou, em vez de embaralhar a comparação com um `NaN`.
 */
const toTimestamp = (date) => {
  if (!date) return 0;
  const timestamp = moment(getLocalTime(date)).valueOf();
  return isNaN(timestamp) ? 0 : timestamp;
}

/** A coluna mistura conversas individuais e grupos, da atividade mais recente para a
 *  mais antiga, que é também a ordem em que a listagem os devolve.
 */
function useSortedConversations(contacts, groups) {
  return React.useMemo(() => {
    return [
      ...contacts.map(contact => ({
        isGroup: false,
        data: contact,
        timestamp: toTimestamp(contact.dateLastMessage)
      })),
      ...groups.map(group => ({
        isGroup: true,
        data: group,
        timestamp: toTimestamp(getGroupActivityDate(group))
      }))
    ].sort((a, b) => b.timestamp - a.timestamp);
  }, [contacts, groups]);
}

export default useSortedConversations;
